export default __webpack_public_path__ + "static/media/mua-sam-1.e6acfe8f.jpg";